<template>
  <div class="hello">
    <modal name="new-auction" transition="pop-out" :width="300" :height="300">
      <div class="box">
        <div class="title">
          <span v-if="auctionType === 'new_auction'">{{$t('i18nView.newAuction')}}:</span>
          {{alertAccount}}
        </div>
        <div class="price-input">
          <input type="number" v-model="myPrice" />

          <div class="token-symbol">TPT</div>
        </div>
        <div v-if="auctionType !== 'new_auction'" class="add-price-warp">
          <span class="add-price" @click="addPrice(500)">+500</span>
          <span class="add-price" @click="addPrice(1000)">+1000</span>
          <span class="add-price" @click="addPrice(2000)">+2000</span>
        </div>

        <div>
          <button class="auction-button" @click="auctionNow">
            <i class="iconfont icon-paimai"></i>
            {{$t('i18nView.auctionConfirm')}}
          </button>
        </div>

        <div v-if="auctionType === 'new_auction'">
          <h6>{{$t('i18nView.basePrice')}}</h6>
          <ul class="price-list">
            <li>7位(4位自定义 + .tp): 3000 TPT</li>
            <li>8位(5位自定义 + .tp): 2000 TPT</li>
            <li>9位(6位自定义 + .tp): 1500 TPT</li>
            <li>10位(7位自定义 + .tp): 1000 TPT</li>
          </ul>
        </div>
        <div v-else>
          <h6>每次竞拍至少加价500 TPT</h6>
        </div>
      </div>
    </modal>
    <modal name="claim-panel" transition="pop-out" :width="300" :height="200">
      <div class="box">
        <div class="title">{{alertAccount}}</div>

        <div class="key-input">
          <label for>{{$t('i18nView.pubkeyToReceive')}}:</label>
          <input type="text" v-model="targetPublicKey" />
        </div>
        <div>
          <button class="auction-button" @click="claimNow">{{$t('i18nView.claim')}}</button>
        </div>
      </div>
    </modal>

    <modal name="tip-panel" transition="pop-out" :width="250" :height="200">{{tips}}</modal>

    <modal name="rule-panel" transition="pop-out" :width="300" :height="400">
      <h5>{{$t('i18nView.rules')}}</h5>
      <h6>{{$t('i18nView.accountLength')}}:</h6>
      <p>{{$t('i18nView.accountLengthDesc')}}</p>
      <h6>{{$t('i18nView.newAccount')}}:</h6>
      <p>{{$t('i18nView.newAccountDesc')}}</p>
      <h6>{{$t('i18nView.process')}}:</h6>
      <p>{{$t('i18nView.processDesc')}}</p>
      <h6>{{$t('i18nView.dealRules')}}:</h6>
      <p>{{$t('i18nView.dealDesc')}}</p>
    </modal>
    <div class="nav">
      <i class="iconfont icon-account"></i>
      <span v-if="currentAccount" class="account-name">
        {{currentAccount}}
        <span v-if="currentBalance">{{currentBalance}}</span>
        <a
          class="exchange"
          href="https://newdex.340wan.com/trade/eosiotptoken-tpt-eos"
          target="_blank"
        >
          <i class="iconfont icon-exchange"></i>
        </a>
        <span class="pc-only" @click="logout">, {{$t('i18nView.logout')}}</span>
      </span>
      <button class="mini-btn" v-else @click="login">{{$t('i18nView.login')}}</button>

      <a class="rule" href="javascript:void(0)" @click="openRule">
        <i class="iconfont icon-question"></i>
      </a>
      <span class="lang-switch">
        <a v-if="$i18n.locale === 'zh'" @click="changeLang('en')" href="javascript:;">En</a>
        <a v-if="$i18n.locale === 'en'" @click="changeLang('zh')" href="javascript:;">中</a>
      </span>
    </div>

    <div class="banner">
      <img v-if="$i18n.locale === 'zh'" src="../assets/banner.png" alt />
      <img v-else src="../assets/banner-en.png" alt />
    </div>

    <div class="search-bar">
      <div class="search-text">
        <input
          type="text"
          maxlength="8"
          v-model="searchAccount"
          :placeholder="$t('i18nView.searchPlaceholder')"
        />
        <span class="suffix">.tp</span>
      </div>
      <div class="search-button">
        <button @click="search">{{$t('i18nView.search')}}</button>
      </div>
    </div>

    <div class="tab">
      <vue-tabs
        type="tabs"
        v-model="tabName"
        activeTextColor="#fff"
        activeTabColor="transparent"
        centered
      >
        <v-tab :title="$t('i18nView.auction')">
          <div class="list-wrap">
            <ul class="auction-list">
              <li v-for="auction in auctionList">
                <h3 class="account-name">{{auction.new_account}}</h3>

                <p class="account-pirce">
                  <label>{{$t('i18nView.currentPrice')}}:</label>
                  {{auction.auction_token}}
                </p>

                <p class="account-owner">
                  <label>{{$t('i18nView.bidder')}}:</label>
                  {{auction.account_owner}}
                </p>

                <span class="account-time">
                  <i class="iconfont icon-count-down"></i>
                  <span
                    v-if="auction.endDateTime - nowDate > 0"
                  >{{parseInt(((auction.endDateTime - nowDate) / 3600000)) + $t('i18nView.hour') + ' ' + parseInt((auction.endDateTime - nowDate) % 3600000 / 60000) + $t('i18nView.minute') + ' ' + parseInt((auction.endDateTime - nowDate) % 60000 / 1000) + $t('i18nView.second') }}</span>
                  <span v-else>{{$t('i18nView.finished')}}</span>
                  <span></span>
                </span>

                <button
                  class="auction-btn"
                  @click="claim(auction.new_account)"
                  v-if="auction.endDateTime - nowDate <= 0 && currentAccount === auction.account_owner"
                >{{$t('i18nView.claim')}}</button>
                <button
                  class="auction-btn disable"
                  v-else-if="auction.endDateTime - nowDate <= 0 && currentAccount !== auction.account_owner"
                >{{$t('i18nView.bidFinished')}}</button>
                <button
                  class="auction-btn disable"
                  v-else-if="currentAccount === auction.account_owner"
                >{{$t('i18nView.bidded')}}</button>
                <button
                  v-else
                  class="auction-btn"
                  @click="goAuction(auction.new_account, auction.auction_token)"
                >{{$t('i18nView.joinBid')}}</button>
              </li>
            </ul>
          </div>
        </v-tab>

        <v-tab :title="$t('i18nView.mine')">
          <div class="login-tip" v-if="!currentAccount">
            <span>{{$t('i18nView.please')}}</span>
            <button class="mini-btn" @click="login">{{$t('i18nView.login')}}</button>
          </div>
          <div v-else class="list-wrap">
            <ul class="auction-list">
              <li v-for="auction in myAuctionList">
                <h3 class="account-name">{{auction.new_account}}</h3>

                <p class="account-pirce">
                  <label>{{$t('i18nView.currentPrice')}}:</label>
                  {{auction.auction_token}}
                </p>

                <p class="account-owner">
                  <label>{{$t('i18nView.bidder')}}:</label>
                  {{auction.account_owner}}
                </p>

                <span class="account-time">
                  <i class="iconfont icon-count-down"></i>
                  <span
                    v-if="auction.endDateTime - nowDate > 0"
                  >{{parseInt(((auction.endDateTime - nowDate) / 3600000)) + '时' + parseInt((auction.endDateTime - nowDate) % 3600000 / 60000) + '分' + parseInt((auction.endDateTime - nowDate) % 60000 / 1000) + '秒' }}</span>
                  <span v-else>{{$t('i18nView.bidFinished')}}</span>
                  <span></span>
                </span>

                <button
                  class="auction-btn disable"
                  v-if="auction.isDeal"
                >{{$t('i18nView.bidFinished')}}</button>
                <button
                  class="auction-btn"
                  @click="claim(auction.new_account)"
                  v-else-if="auction.endDateTime - nowDate <= 0 && currentAccount === auction.account_owner"
                >{{$t('i18nView.claim')}}</button>
                <button
                  class="auction-btn disable"
                  v-else-if="auction.endDateTime - nowDate <= 0 && currentAccount !== auction.account_owner"
                >{{$t('i18nView.bidFinished')}}</button>
                <button
                  class="auction-btn disable"
                  v-else-if="currentAccount === auction.account_owner"
                >{{$t('i18nView.bidded')}}</button>
                <button
                  v-else
                  class="auction-btn"
                  @click="goAuction(auction.new_account, auction.auction_token)"
                >{{$t('i18nView.joinBid')}}</button>
              </li>
            </ul>
          </div>
        </v-tab>

        <v-tab :title="$t('i18nView.deal')">
          <ul class="auction-list">
            <li v-for="deal in dealList">
              <h3 class="account-name">{{deal.new_account}}</h3>

              <p>
                <span class="account-pirce">{{$t('i18nView.dealPrice')}}: {{deal.auction_token}}</span>
                <span class="account-owner deal">{{$t('i18nView.bidOwner')}}: {{deal.account_owner}}</span>
              </p>

              <span class="account-time">{{$t('i18nView.dealTime')}}: {{deal.deal_time | date}}</span>
            </li>
          </ul>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>

<script>
import ScatterJS from "scatterjs-core";
import ScatterEOS from "scatterjs-plugin-eosjs";
import Eos from "eosjs";
import dayjs from "dayjs";
import _ from "lodash";
import { Settings } from "luxon";

ScatterJS.plugins(new ScatterEOS());

// mainnet
const network = ScatterJS.Network.fromJson({
  blockchain: "eos",
  chainId: "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906",
  host: "eospush.tokenpocket.pro",
  port: 443,
  protocol: "https"
});

// kylin
// const network = ScatterJS.Network.fromJson({
//   blockchain: "eos",
//   chainId: "5fff1dae8dc8e2fc4d5b23b2c7665c97f9e9d8edf2b6485a86ba311c25639191",
//   host: "api-kylin.eoslaomao.com",
//   port: 443,
//   protocol: "https"
// });

// const FORMAT = function(time) {
//   return time;
// };

const SUFFIX = ".tp";

// const TOKEN = "EOS";
const TOKEN = "TPT";

const TOKEN_CONTRACT = "eosiotptoken";
// const TOKEN_CONTRACT = "eosio.token";

// const MAIN_CONTRACT = "tpauction111";
const MAIN_CONTRACT = "bidname.tp";

const chainId = network.chainId;
const httpEndpoint =
  network.protocol + "://" + network.host + ":" + network.port;

const readOnlyEos = Eos({
  chainId,
  httpEndpoint
});

let eosClient = null;

const GET_BASE_PRICE = function(account) {
  if (!account) {
    return 1000;
  }
  switch (account.length) {
    case 6:
      return 5000;
    case 7:
      return 3000;
    case 8:
      return 2000;
    case 9:
      return 1500;
    case 10:
      return 1000;
    case 11:
      return 1000;
    default:
      return 1000;
  }
};

const requiredFields = { accounts: [network] };

export default {
  name: "HelloWorld",
  data() {
    return {
      auctionList: [],
      myAuctionList: [],
      dealList: [],
      scatterInstance: null,
      currentAccount: null,
      currentPermission: "",
      currentBalance: "",
      searchAccount: "",
      tabName: "",
      alertAccount: ".tp",
      myPrice: "1000",
      auctionType: "",
      targetPublicKey: "",
      publicKey: "",
      nowDate: new Date().getTime(),
      tips: ""
    };
  },
  filters: {
    date: function(value) {
      if (!value) return "";
      return dayjs(value * 1000).format("MM-DD HH:mm");
    }
  },
  computed: {
    searched: function() {
      return _.trim(this.searchAccount) + SUFFIX;
    }
  },
  created() {
    ScatterJS.scatter.connect("tp-short", { network }).then(connected => {
      if (!connected) return console.error("no scatter");
      this.scatterInstance = ScatterJS.scatter;
      eosClient = this.scatterInstance.eos(network, Eos);

      // window.eosClient = eosClient;

      this.login();
    });

    this.getAuctionList();
    this.getDealList();

    this.nowDate = new Date().getTime();
    setInterval(() => {
      this.nowDate = this.nowDate + 1000;
    }, 1000);
  },
  methods: {
    claim(account) {
      this.alertAccount = account;
      this.targetPublicKey = this.publicKey;
      this.$modal.show("claim-panel");
    },
    addPrice(value) {
      this.myPrice = parseFloat(parseFloat(this.myPrice) + value).toFixed(4);
    },
    claimNow() {
      if (!this.targetPublicKey) {
        alert(this.$t("i18nView.PublicKeyFirst"));
        return;
      }

      if (!this.currentAccount) {
        alert(this.$t("i18nView.loginFirst"));
        return;
      }

      eosClient
        .transaction({
          actions: [
            {
              account: MAIN_CONTRACT,
              name: "claim",
              authorization: [
                {
                  actor: this.currentAccount,
                  permission: this.currentPermission
                }
              ],
              data: {
                new_account_name: this.alertAccount,
                public_key_str: this.targetPublicKey
              }
            }
          ]
        })
        .then(res => {
          alert(this.$t("i18nView.claimSuccess"));
          // this.tips = "领取成功";
          this.$modal.hide("claim-panel");
          // this.$modal.show("tip-panel");

          this.queryAllInfo();
          // console.log(res);
        })
        .catch(err => {
          this.handleError(err);
        });
    },
    auctionNow() {
      if (!eosClient || !this.currentAccount) {
        alert(this.$t("i18nView.loginFirst"));
        return;
      }

      let memoKey =
        this.auctionType === "new_auction" ? "new_account" : "auction_account";

      let memo =
        "action_type:" +
        this.auctionType +
        "&" +
        memoKey +
        ":" +
        this.alertAccount;

      eosClient
        .transaction({
          actions: [
            {
              account: TOKEN_CONTRACT,
              name: "transfer",
              authorization: [
                {
                  actor: this.currentAccount,
                  permission: this.currentPermission
                }
              ],
              data: {
                from: this.currentAccount,
                to: MAIN_CONTRACT,
                quantity: parseFloat(this.myPrice).toFixed(4) + " " + TOKEN,
                memo: memo
              }
            }
          ]
        })
        .then(res => {
          this.$modal.hide("new-auction");
          alert(this.$t("i18nView.bidSuccess"));
          this.queryAllInfo();
        })
        .catch(err => {
          this.handleError(err);
        });
    },
    goAuction(account, price) {
      if (!this.currentAccount) {
        alert(this.$t("i18nView.loginFirst"));
        return;
      }
      this.auctionType = "join_auction";
      this.alertAccount = account;
      this.myPrice = parseFloat(parseFloat(price) + 500).toFixed(4);
      this.$modal.show("new-auction");
    },
    logout() {
      this.scatterInstance.forgetIdentity();
      this.currentAccount = null;
      this.currentBalance = null;
    },
    login() {
      this.scatterInstance
        .getIdentity(requiredFields)
        .then(id => {
          if (!id) {
            return console.error("no identity");
          }
          this.currentAccount = id.accounts[0].name;
          this.currentPermission = id.accounts[0].authority;
          this.publicKey = id.accounts[0].publicKey;

          this.getMybalance();
          this.getMyAuctionList();
        })
        .catch(err => {
          this.handleError(err);
        });
    },
    getAuctionList() {
      readOnlyEos
        .getTableRows(
          true,
          MAIN_CONTRACT,
          MAIN_CONTRACT,
          "auction",
          "",
          "",
          "",
          1000
        )
        .then(res => {
          if (res && res.rows.length) {
            _.forEach(res.rows, item => {
              item.endDateTime = new Date(item.end_time).getTime() * 1000;
            });

            res.rows.sort(function(a, b) {
              return parseInt(b.auction_token) - parseInt(a.auction_token);
            });

            this.auctionList = res.rows;
          } else {
            this.auctionList = res.rows;
          }
        });
    },
    changeLang(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem("locale", lang);
      if (lang === "en") {
        Settings.defaultLocale = "en-US";
      } else {
        Settings.defaultLocale = "zh-CN";
      }
    },
    queryAllInfo() {
      this.getAuctionList();
      this.getMyAuctionList();
      this.getDealList();
    },
    getMyAuctionList() {
      if (!this.currentAccount) {
        return;
      }

      var api1 = readOnlyEos.getTableRows(
        true,
        MAIN_CONTRACT,
        MAIN_CONTRACT,
        "auction",
        "",
        this.currentAccount,
        this.currentAccount,
        1000,
        "i64",
        2
      );
      var api2 = readOnlyEos.getTableRows(
        true,
        MAIN_CONTRACT,
        MAIN_CONTRACT,
        "deal",
        "",
        this.currentAccount,
        this.currentAccount,
        1000,
        "i64",
        2
      );

      Promise.all([api1, api2]).then(res => {
        let myauction = res[0].rows && res[0].rows.length ? res[0].rows : [];
        let mydeal = res[1].rows && res[1].rows.length ? res[1].rows : [];

        _.forEach(myauction, item => {
          item.endDateTime = new Date(item.end_time).getTime() * 1000;
          item.isDeal = false;
        });

        _.forEach(mydeal, item => {
          item.endDateTime = new Date(item.deal_time).getTime() * 1000;
          item.isDeal = item.is_claimed === 1;
        });

        this.myAuctionList = myauction.concat(mydeal);
      });
    },

    getMybalance() {
      if (this.currentAccount) {
        readOnlyEos
          .getCurrencyBalance(TOKEN_CONTRACT, this.currentAccount, TOKEN)
          .then(res => {
            this.currentBalance = res[0];
          });
      }
    },
    search() {
      if (this.searched === ".tp") {
        this.getAuctionList();
        this.getDealList();
        return;
      }

      if (this.searched.length < 7 || this.searched.length > 10) {
        alert(this.$t("i18nView.lengthTips"));
        return;
      }

      var api1 = readOnlyEos.getTableRows(
        true,
        MAIN_CONTRACT,
        MAIN_CONTRACT,
        "auction",
        "",
        this.searched,
        this.searched,
        1
      );
      var api2 = readOnlyEos.getTableRows(
        true,
        MAIN_CONTRACT,
        MAIN_CONTRACT,
        "deal",
        "",
        this.searched,
        this.searched,
        1
      );

      Promise.all([api1, api2]).then(res => {
        if (
          res[1].rows &&
          res[1].rows.length &&
          res[1].rows[0].new_account === this.searched
        ) {
          this.dealList = res[1].rows;

          this.tabName = 2;
          return;
        }

        if (
          res[0].rows &&
          res[0].rows.length &&
          res[0].rows[0].new_account === this.searched
        ) {
          _.forEach(res[0].rows, item => {
            item.endDateTime = new Date(item.end_time).getTime() * 1000;
          });
          this.auctionList = res[0].rows;
          this.tabName = 0;
          return;
        }

        // 没有竞拍过 弹窗 竞拍
        var temsss = this.searched;

        this.alertAccount = temsss;

        this.auctionType = "new_auction";

        this.myPrice = parseFloat(GET_BASE_PRICE(this.searched)).toFixed(4);

        this.$modal.show("new-auction");
      });
    },
    getDealList() {
      readOnlyEos
        .getTableRows(
          true,
          MAIN_CONTRACT,
          MAIN_CONTRACT,
          "deal",
          "",
          "",
          "",
          1000
        )
        .then(res => {
          if (res && res.rows.length) {
            res.rows.sort(function(a, b) {
              return parseInt(b.auction_token) - parseInt(a.auction_token);
            });

            this.dealList = res.rows;
          } else {
          }
        });
    },
    openRule() {
      this.$modal.show("rule-panel");
    },
    handleError(err) {
      if (typeof err === "string") {
        try {
          let errJson = JSON.parse(err);
          if (errJson.error && errJson.error.details.length) {
            alert(errJson.error.details[0].message);
          } else if (errJson.error) {
            alert(errJson.error.what);
          } else {
            alert(errJson.message || errJson.code || errJson.msg);
          }
        } catch (e) {
          alert(e);
        }
      } else {
        alert(err.message || err.type || err.code);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
h3 {
  margin: 5px 0 10px;
  font-size: 18px;
}

p {
  margin: 5px 0;
}
.iconfont {
  font-size: 16px;
  display: inline-block;
  vertical-align: middle;
}

.lang-switch {
  float: right;
  display: inline-block;
  font-weight: bold;
  margin-right: 6px;
}

.lang-switch a {
  line-height: 20px;
  text-decoration: none;
  padding: 0 2px;
  color: #ddd;
}

button {
  padding: 5px 20px;
  min-width: 90px;
  border-radius: 100px;
  border: 1px solid #ffde27;
  background: transparent;
  color: #ffde27;
  font-weight: bold;
  font-size: 14px;
}
button.disable {
  border: 1px solid #ddd;
  color: #ddd;
}
.hello {
  padding: 10px 16px;
  font-size: 12px;

  .v--modal-box {
    width: 80%;
    max-width: 400px;
    padding: 20px;
    border-radius: 25px;
    color: #333;

    .title {
      text-align: center;
      font-size: 24px;
      color: #333;

      span {
        font-size: 16px;
      }
    }
  }
}

.box {
  color: #333;

  input {
    margin: 10px 0;
    font-size: 15px;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 12px 5px;
    text-align: center;
    border: 1px solid #999;
    box-shadow: #999 inset 0 0 10px 0px;
  }
}

h5 {
  font-size: 16px;
}

h6 {
  margin: 14px 0 4px;
  color: #999;
  font-size: 14px;
}

.nav {
  text-align: left;
  margin: 10px 4px;

  .icon-account {
    margin-right: 4px;
  }

  span {
    font-size: 14px;
    font-weight: bold;
  }
}

.exchange {
  color: #ddd;
  margin: 0 4px;
}

.mini-btn {
  margin: 0 4px;
  padding: 2px 10px;
  font-size: 13px;
}

.rule {
  float: right;
  color: #fff;
  text-decoration: none;
}

.price-list {
  margin: 4px 0;
  padding: 0;
  list-style: none;
}

.banner img {
  width: 100%;
}
.hello {
  .vue-tabs .nav > li {
    > a {
      font-weight: bold;
      font-size: 16px;
      padding: 0 10px;
      border: none !important;
      border-radius: 0 !important;
      border-right: 1px solid #808080 !important;
    }
    &:last-child a {
      border-right: none !important;
    }
  }
}

.vue-tabs .nav > li > a:hover,
.vue-tabs .nav > li > a:focus {
  background: transparent !important;
}

.search-bar {
  position: relative;
  margin: 10px 0 20px;

  .search-text {
    margin-right: 120px;
  }

  input {
    width: 100%;
    line-height: 24px;
    border-radius: 100px;
    -webkit-appearance: none;
    border: 1px solid #aaa;
    outline: none;
    padding: 2px 10px;
    background: transparent;
    color: #fff;
    font-size: 14px;
  }
}

.auction-list {
  list-style: none;
  padding: 0;

  li {
    padding: 15px 20px;
    text-align: left;
    background-color: #1d1b26;
    border-radius: 8px;
    margin-bottom: 12px;
    position: relative;

    label {
      color: #797a82;
      min-width: 50px;
      text-align: right;
      display: inline-block;
      margin-right: 5px;
    }
  }

  button.auction-btn {
    position: absolute;
    right: 15px;
    bottom: 20px;
  }

  .account-time {
    position: absolute;
    top: 20px;
    right: 15px;

    span {
      display: inline-block;
      vertical-align: middle;
    }
  }
}

.add-price-warp {
  margin: 10px 0;
  height: 50px;
}

.add-price {
  position: relative;
  background-color: #ffce60;
  padding: 10px 0;
  user-select: none;
  width: 25%;
  display: inline-block;
  font-weight: bold;
  margin-right: 12%;
  float: left;
  box-sizing: border-box;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  box-shadow: #fa9412 inset 0 0 15px 0;
  transform: rotate(-20deg);

  &:after {
    content: "";
    display: block;
    width: 10px;
    height: 18px;
    left: 27px;
    top: 36px;
    position: absolute;
    background-color: #ffce60;
    box-shadow: #fa9412 inset 0 0 15px 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.icon-count-down {
  font-size: 14px;
  margin-right: 4px;
}
.account-owner.deal {
  float: right;
}
.suffix {
  position: absolute;
  right: 110px;
  font-weight: bold;
  top: 2px;
  font-size: 18px;
}

.login-tip {
  font-size: 14px;
  margin: 20px 0;
}

.auction-button {
  background: #f9e458;
  background: -moz-linear-gradient(top, #f9e458 0%, #fa8e0e 100%);
  background: -webkit-linear-gradient(top, #f9e458 0%, #fa8e0e 100%);
  background: linear-gradient(to bottom, #f9e458 0%, #fa8e0e 100%);
  color: #fff;

  width: 100%;
  font-size: 16px;
  padding: 8px 20px;

  .icon-paimai {
    color: #fff;
    margin-right: 10px;
  }
}

.search-button {
  position: absolute;
  right: 0;
  top: 0;

  // button {
  //   padding: 5px 20px;
  //   border-radius: 100px;
  //   border: 1px solid #ffde27;
  //   background: transparent;
  //   color: #ffde27;
  //   font-weight: bold;
  //   font-size: 14px;
  // }
}

.price-input {
  position: relative;
}

.token-symbol {
  position: absolute;
  top: 22px;
  right: 20px;
  font-size: 16px;
}

.pc-only {
  display: none;
}

@media screen and (min-width: 768px) {
  .pc-only {
    display: inline-block;
  }
}

@media screen and (max-width: 321px) {
  .hello {
    padding: 10px 10px;
  }
}

@media (min-width: 320px) {
  .vue-tabs .nav-justified > li,
  .vue-tabs .nav-tabs.nav-justified > li {
    display: table-cell;
    width: 1%;
  }
}
</style>
